import { useMemo } from 'react';
import { useMiningAccountSignedIn, useUserSignedIn } from '../../api';

export enum RequireSignInLevel {
  User = 'user',
  MiningAccount = 'mining-account',
}

export const useElevationSignInCheck = (level: RequireSignInLevel) => {
  const { isSignedIn: isUserSignedIn, isLoading: isLoadingUserSignIn } = useUserSignedIn();
  const { isSignedIn: isMiningAccountSignedIn, isLoading: isLoadingMiningAccountSignIn } = useMiningAccountSignedIn();

  return useMemo(() => {
    const signInStatusLevel = [
      {
        level: RequireSignInLevel.User,
        status: isUserSignedIn,
        isLoading: isLoadingUserSignIn,
      },
      {
        level: RequireSignInLevel.MiningAccount,
        status: isMiningAccountSignedIn,
        isLoading: isLoadingMiningAccountSignIn,
      },
    ];

    let finalStatus: { status: boolean; highestLevel: RequireSignInLevel; isLoading?: boolean } = undefined;
    for (const { level: currentLevel, status, isLoading } of signInStatusLevel) {
      if (level === currentLevel || !status) {
        finalStatus = { status, highestLevel: currentLevel, isLoading };
        break;
      }
    }
    if (finalStatus === undefined) {
      finalStatus = { status: false, highestLevel: level, isLoading: false };
    }

    return finalStatus;
  }, [isUserSignedIn, isMiningAccountSignedIn, level, isLoadingUserSignIn, isLoadingMiningAccountSignIn]);
};
